import styled from "styled-components/macro";
import { ButtonPrimary } from "../../../../components";
import { media } from "../../../../utils";

export const SelectTitle = styled.p`
  font-size: 14px;
  color: #424242;
`;

export const ButtonCondicoesGerais = styled(ButtonPrimary)`
  display: block;
  border-radius: 500px;
  width: 100%;
  padding-top: 8px;

  ${media.md()} {
    max-width: 221px;
  }
`;

export const FormContent = styled.div`
  ${media.md()} {
    width: 30%;
  }
`;

export default ButtonCondicoesGerais;
